<!-- Getting Guest user details as per the webapp setting flag if flag on then it will required -->
<ng-template #guestuser let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
                'justify-content': 'right',
                height: '40px',
                backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                'border-bottom':
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }">
    <a (click)="close()" id="btnnotification" class="close-icon">
      <i [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                  }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
  </div>
  <div class="modal-body">
    @if ((Merchant$ | async)?.webapp_settings?.is_guest_email) {
      <div class="form-group">
        <label [ngStyle]="{
                                                    color: (Merchant$ | async)?.webapp_settings?.menu_color,
                                                  }">Email</label>
        <input [(ngModel)]="email" type="text" name="txtEmail" required class="form-control form-control-lg"
          placeholder="Email" />
        </div>
    }
    @if ((Merchant$ | async)?.webapp_settings?.is_guest_phone) {
      <div class="form-group">
        <!-- <label [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_color}">Please enter mobile number with
        country code in international dialling format: eg. +971501234567 or +441234567890 </label> -->
        <label [ngStyle]="{
                                                    color: (Merchant$ | async)?.webapp_settings?.menu_color,
                                                  }">Pleas select country code from dropdown and enter mobile number
          without leading 0, eg. (+971) 501234567 or (+44) 7747123456.</label>
        <p [ngStyle]="{
                                                    color: (Merchant$ | async)?.webapp_settings?.menu_color,
                                                    'font-weight': 'bold',
                                                  }">
          (Tip: to select country code either scroll or start typing)
        </p>
        <div class="mt-4">
          <ng-select [items]="dialCodes" bindLabel="name" bindValue="name" class="ng-select-md" appendTo="body"
            [(ngModel)]="selectedCode">
          </ng-select>
          <input [(ngModel)]="phone" type="text" name="txtphone" required class="mt-2 form-control" placeholder=" Phone Number" />
          </div>
          </div>
    }
    <div class="d-grid">
      <button type="button" (click)="collectGuestuserinfo()" class="btn btn-lg mt-4" [ngStyle]="{
                                        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                                        color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                                        border:
                                          (Merchant$ | async)?.webapp_settings?.menu_border_width +
                                          'px solid ' +
                                          (Merchant$ | async)?.webapp_settings?.menu_border_color,
                                      }">
        Submit
      </button>

      <!-- <button id="btnclose" class="btn btn-lg mt-2"
        [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :(Merchant$ | async)?.webapp_settings?.menu_border_width +
'px solid ' + (Merchant$ | async)?.webapp_settings?.menu_border_color}"
        (click)="close();"> Cancel</button> -->
    </div>
  </div>
  <!-- <div class="modal-footer">
    <button id="btnclose"
      [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :(Merchant$ | async)?.webapp_settings?.menu_border_width +
'px solid ' + (Merchant$ | async)?.webapp_settings?.menu_border_color}"
      (click)="close();"> Cancel</button>
  </div> -->
</ng-template>
